import { render, staticRenderFns } from "./commercialReserveAdmin.vue?vue&type=template&id=a71f3f14"
import script from "./commercialReserveAdmin.vue?vue&type=script&lang=js"
export * from "./commercialReserveAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports